import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button } from '@asu/components-core';
import StaticData from './StaticData';
import useServiceAuth from 'auth/useServiceAuth';
import { templateCopy } from 'apis/templateAPIs';

const CopyTemplate = ({ id, name, handleClose }) => {
  const { getAccessToken } = useServiceAuth();

  const [toYear, setToYear] = useState(null);

  // Copy new template to database
  const { mutate: copyTemplate } = useMutation({
    mutationFn: templateCopy,
    onSuccess: async (data, { token }) => {
      handleClose();
    },
  });

  const handleCopyTemplate = async () => {
    const token = await getAccessToken();
    copyTemplate({
      jsonData: { id, yearTo: toYear },
      token,
    });
  };

  return (
    <div className="p-6" style={{ width: '500px' }}>
      <h4 className="fs-4 fw-bold mb-4">Copy {name} template</h4>
      <div className="mb-4">
        <h6 className="fw-bold">Copy to catalog year</h6>
        <select
          value={toYear ?? ''}
          onChange={(e) => setToYear(e.target.value)}
        >
          <option value="">Select a year</option>
          {StaticData.yearList.map((year) => (
            <option key={year.value} value={year.value}>
              {year.label}
            </option>
          ))}
        </select>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        <Button
          color="dark"
          label="Cancel"
          size="medium"
          onClick={handleClose}
        />
        <Button
          color="gold"
          label="Copy template"
          size="medium"
          onClick={handleCopyTemplate}
          disabled={!toYear}
        />
      </div>
    </div>
  );
};

export default CopyTemplate;
